// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`TopBar test Match con el snapshot 1`] = `""`;
